import { NavLink } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { SITE_CONFIG } from "@/config/constants";
import { footerContent } from "@/app/content/landingContent";

const logoWhiteUrl = "/images/logo-white.svg";

export function Footer() {
  const scrollToTop = () => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reducedMotion ? "instant" : "smooth" });
  };

  return (
    <footer
      className="bg-slate-900 text-white py-12 md:py-16 px-6"
    >
      <div className="max-w-7xl mx-auto">
        <h2 className="sr-only">Stopka</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          <div>
            <img
              src={logoWhiteUrl}
              alt="Bastun"
              width={160}
              height={32}
              loading="lazy"
              decoding="async"
              className="h-8 w-auto mb-6"
            />
            <p className="text-slate-400 leading-relaxed mb-6 text-base max-w-[65ch]">
              {footerContent.company.description}
            </p>
          </div>

          <div>
            <h2 className="text-lg mb-6 font-semibold">
              {footerContent.quickLinks.heading}
            </h2>
            <ul className="space-y-4">
              {footerContent.quickLinks.links.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-slate-900 rounded-md px-2 py-1 inline-block transition-colors text-base"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg mb-6 font-semibold">
              {footerContent.legal.heading}
            </h2>
            <ul className="space-y-4">
              {footerContent.legal.links.map((link) => (
                <li key={link.id}>
                  <NavLink
                    to={link.href}
                    className={({ isActive }) =>
                      `text-slate-400 hover:text-white focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-slate-900 rounded-md px-2 py-1 inline-flex transition-colors text-base ${isActive ? "text-white font-semibold" : ""
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg mb-6 font-semibold">
              {footerContent.contact.heading}
            </h2>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${SITE_CONFIG.email}`}
                  className="text-slate-400 hover:text-white focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-slate-900 rounded-md px-2 py-1 inline-block transition-colors text-base"
                >
                  {SITE_CONFIG.email}
                </a>
              </li>
              <li>
                <span className="text-slate-400 text-base px-2">
                  {SITE_CONFIG.location}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-400 text-center md:text-left leading-relaxed text-sm">
            {footerContent.bottomBar.lines[0]}
            <br />
            {footerContent.bottomBar.lines[1]}
          </p>

          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-slate-400 hover:text-white focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-slate-900 rounded-md px-4 py-2 transition-colors text-sm font-medium"
            aria-label={footerContent.bottomBar.scrollTopLabel}
          >
            <ArrowUp size={18} aria-hidden="true" />
            {footerContent.bottomBar.scrollTopLabel}
          </button>
        </div>
      </div>
    </footer>
  );
}
